import { useState, useEffect } from 'react'
import { OrderList } from 'modules/orders/components'
import type { FC } from 'react'
import { CustomerOrderService, CustomerService } from 'modules/customers/services'
import { useUserSession } from 'hooks/use-user-session'
import { User } from 'framework/users'
import parser from 'fazendinha/orders'
import { Loading } from 'components/ui'
import type { UserOrderListProps } from '.'

const UserOrdersList: FC<UserOrderListProps> = () => {
  const { user } = useUserSession()
  const [orders, setOrders] = useState<any[]>(null as unknown as any[])
  const [loading, setLoading] = useState<boolean>(false)

  async function getCustomerOrder() {
    try {
      setLoading(true)
      const customerService = new CustomerService(user as User)
      const customerOrderService = new CustomerOrderService(customerService)
      const data = await customerOrderService.list()
      const nextOrders = data.data.orders.map((item: any) => parser(item))
      setOrders(nextOrders.reverse())
    } catch (e) {
      //
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCustomerOrder()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading && <Loading />}
      {orders && <OrderList orders={orders} />}
    </>
  )
}

export default UserOrdersList
